module.exports = __webpack_public_path__ + "media/images/mat-af164a83e39dd3c7126bb249fb67c627.png";